import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { CellProps } from 'react-table';
import { ConfigurationStatusBox } from '~components/configurations/ConfigurationStatus';
import { ConfigurationStatus } from '~graphql/__generated__/types';
import { ConfigurationTable_ConfigurationFragment } from '../__generated__/ConfigurationsTable.graphql';

export function DraftStatusCell({
  value,
  row,
}: PropsWithChildren<
  CellProps<ConfigurationTable_ConfigurationFragment, ConfigurationStatus | null>
>) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    const config = row.original;
    navigate(`${config.id}/config-summary`, {
      state: { showPublished: false },
    });
  };
  return (
    <Box
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
      fontWeight="semibold"
      onClick={handleClick}
    >
      {value && <ConfigurationStatusBox state={value} />}
    </Box>
  );
}

DraftStatusCell.graphql = {
  fragments: {
    DraftStatusCell_powerSchedule: gql`
      fragment DraftStatusCell_configuration on ConfigurationModel {
        id
        version
        draft {
          id
        }
      }
    `,
  },
};
